/**
 * Loading page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var Page = require('stb-component-page'),
    page = new Page({$node: window.pageInit});


// public
module.exports = page;
